import React, { useEffect } from 'react'
import { Link, Navigate } from "react-router-dom";

import { useState } from 'react';
import LogoN7 from '../../../Img/LogoN7_FondoTransparente.png';
import LogoLatitudVirtual from '../../../Img/LogoLV_FondoTransparente.png';
import { function_ABM_ZON_Plantas_Leer } from 'neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Plantas';

export const PaginaExternaProveedor = (props) => {
    const { children, Titulo, CodigoCompania, CodigoEmpresa = "E01", CodigoPlanta = "P01" } = props;
    const [selectedOption, setSelectedOption] = useState('/CSS/dx.light.css');
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const [logo, setLogo] = useState(null);

    React.useEffect(() => {
        if (!selectedOption) return;

        const existing = document.getElementById('theme-link');
        if (existing) {
            existing.href = selectedOption;
            return;
        }

        const link = document.createElement('link');
        link.id = 'theme-link';
        link.rel = 'stylesheet';
        link.href = selectedOption;
        document.head.appendChild(link);

        return () => {
            const el = document.getElementById('theme-link');
            if (el) document.head.removeChild(el);
        };
    }, []);

    React.useEffect(() => {
        if (!selectedOption) return;

        const existing = document.getElementById('theme-link');
        if (existing) {
            existing.href = selectedOption;
            return;
        }

        const link = document.createElement('link');
        link.id = 'theme-link';
        link.rel = 'stylesheet';
        link.href = selectedOption;
        document.head.appendChild(link);

        return () => {
            const el = document.getElementById('theme-link');
            if (el) document.head.removeChild(el);
        };
    }, [selectedOption]);

    useEffect(() => {
        const codigoCompania = localStorage.getItem("CodigoCompania");
        const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
        const codigoPlanta = localStorage.getItem("CodigoPlanta");
        const idProveedor = localStorage.getItem("IdProveedor");

        try {
            const defaultLogo = require(`../../../Img/${localStorage.getItem("CodigoCompania")}/${localStorage.getItem("CodigoEmpresa")}/${localStorage.getItem("CodigoPlanta")}/logoFondoTransparente.png`);
            setLogo(defaultLogo);
        } catch (error) {
            const fallbackLogo = require(`../../../Img/LogoLV_FondoTransparente.png`);
            setLogo(fallbackLogo);
        }

        // Verificar valores en localStorage
        if (!codigoCompania || codigoCompania === "null" || codigoCompania === "undefined" || codigoCompania.trim() === "" ||
            !codigoEmpresa || codigoEmpresa === "null" || codigoEmpresa === "undefined" || codigoEmpresa.trim() === "" ||
            !codigoPlanta || codigoPlanta === "null" || codigoPlanta === "undefined" || codigoPlanta.trim() === "" ||
            !idProveedor || isNaN(Number(idProveedor)) || Number(idProveedor) < 1) {
            setShouldRedirect(true);
        }

        const getData = async () => {
            const datosDocumento = await function_ABM_ZON_Plantas_Leer(codigoPlanta)

            if (datosDocumento.data[0]?.Logo) {
                let mimeType = "image/jpeg"; // Valor por defecto

                // Detectar el formato a partir del encabezado de la cadena Base64
                if (datosDocumento.data[0].Logo.startsWith("/9j/")) mimeType = "image/jpeg";
                else if (datosDocumento.data[0].Logo.startsWith("iVBOR")) mimeType = "image/png";
                else if (datosDocumento.data[0].Logo.startsWith("R0lGOD")) mimeType = "image/gif";

                const logoUrl = `data:${mimeType};base64,${datosDocumento.data[0].Logo}`;
                setLogo(logoUrl);
            }
        }

        getData()
    }, []);

    if (shouldRedirect) {
        return <Navigate to="/PortalProveedoresLogin" />;
    }

    return (
        <div id="content-wrapper" style={{ height: "97vh", flexGrow: 1, overflow: "auto", marginTop: "10px" }}>
            {/* Izquierda: Logo */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                minWidth: '100%',
                padding: '0 15px'
            }}>
                {/* Logo del cliente a la izquierda */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {logo && (
                        <img
                            src={logo}
                            alt="Logo Cliente"
                            style={{ maxHeight: '50px', objectFit: 'contain' }}
                        />
                    )}
                </div>

                {/* Logos N7 y Latitud Virtual a la derecha */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={LogoN7}
                        alt="Logo N7"
                        style={{ maxHeight: '50px', marginRight: '10px', objectFit: 'contain' }}
                    />
                    <img
                        src={LogoLatitudVirtual}
                        alt="Logo Latitud Virtual"
                        style={{ maxHeight: '50px', objectFit: 'contain' }}
                    />
                </div>
            </div>

            {/* Contenido escalado con zoom (no afecta scroll) */}
            <div style={{ zoom: 0.85 }}>
                {children}
            </div>
        </div>
    );
}